import {
  CarrierFormValues,
  ConsigneeFormValues,
  ConsignorFormValues,
  TraderType,
} from 'features/declaration/models/schemas/tradersSchema'
import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import {
  isCarrier, isConsignee, isConsignor, nonNullCarrier, nonNullConsignee, nonNullConsignorIgnoringContactPerson,
} from 'features/declaration/models/helpers'
import { ErrorResult, SaveResult } from '../../../../shared/models/types'
import { ConsignmentDetailDetails } from '../../consignment-detail/models/types'
import useSaveConsignmentDetail from '../../consignment-detail/components/useSaveConsignmentDetail'

type SaveConsignmentDetailsFn = (
  transitOperationId: number,
  isDraft: boolean,
  trader: TraderType
) => Promise<SaveResult<ConsignmentDetailDetails>>

type SaveTradersResult = {
  consignee: ConsigneeFormValues | null
  consignor: ConsignorFormValues | null
  carrier: CarrierFormValues | null
  errors: ErrorResult[]
}

async function saveConsignmentTraders(
  transitOperationId: number,
  isDraft: boolean,
  formValues: TransitOperationFormValues,
  saveFn: SaveConsignmentDetailsFn,
) {
  const result: SaveTradersResult = {
    consignee: null,
    consignor: null,
    carrier: null,
    errors: [],
  }

  if (formValues.consignee != null && nonNullConsignee(formValues.consignee)) {
    const consigneeSaveResult = await saveFn(transitOperationId, isDraft, formValues.consignee)
    if (consigneeSaveResult.data && isConsignee(consigneeSaveResult.data)) {
      result.consignee = consigneeSaveResult.data
    } else {
      result.errors.push(...consigneeSaveResult.errors)
    }
  }

  if (formValues.consignor != null && nonNullConsignorIgnoringContactPerson(formValues.consignor)) {
    const consignorSaveResult = await saveFn(transitOperationId, isDraft, formValues.consignor)
    if (consignorSaveResult.data && isConsignor(consignorSaveResult.data)) {
      result.consignor = consignorSaveResult.data
    } else {
      result.errors.push(...consignorSaveResult.errors)
    }
  }

  if (formValues.carrier != null && nonNullCarrier(formValues.carrier)) {
    const carrierSaveResult = await saveFn(transitOperationId, isDraft, formValues.carrier)
    if (carrierSaveResult.data && isCarrier(carrierSaveResult.data)) {
      result.carrier = carrierSaveResult.data
    } else {
      result.errors.push(...carrierSaveResult.errors)
    }
  }

  return result
}

function useSaveConsignmentTraderFormValues() {
  const { saveConsignmentDetail } = useSaveConsignmentDetail()

  const saveTraders = async (
    transitOperationId: number,
    isDraft: boolean,
    formValues: TransitOperationFormValues,
  ) => await saveConsignmentTraders(transitOperationId, isDraft, formValues, saveConsignmentDetail)

  return {
    saveTraders,
  }
}

export default useSaveConsignmentTraderFormValues
